import React, { Component } from 'react';
import { connect } from 'react-redux'
import close from "./images/close.png"
import instruction from "./images/instruction.png"
import {toggleIntro} from "./actions/user";
import './Intro.css'

class Intro extends Component {
  render() {
    const {showIntro, toggleIntro} = this.props
    if(!showIntro){
      return null
    }
    return <div className={"intro-container"} >
      <div className={"intro-wrapper"}>
        <div className={"intro-close"} style={{
          backgroundImage: `url(${close})`
        }} onClick={toggleIntro}>
        </div>
        <div className={"intro-image"}>
          <img src={instruction} />
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showIntro: state.user.showIntro,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleIntro: ()=>dispatch(toggleIntro())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Intro)





// WEBPACK FOOTER //
// ./src/Intro.js